var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_7984",
    "data-name": "\\uADF8\\uB8F9 7984",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12643",
    "data-name": "\\uD328\\uC2A4 12643",
    d: "M212.464,172H200.536A4.536,4.536,0,0,1,196,167.464V155.536A4.536,4.536,0,0,1,200.536,151h11.928A4.536,4.536,0,0,1,217,155.536v11.928A4.536,4.536,0,0,1,212.464,172",
    transform: "translate(-196 -151)",
    fill: "#1861ad"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12644",
    "data-name": "\\uD328\\uC2A4 12644",
    d: "M214.4,174.307l3.077-.046.161,9.122-3.077.046Zm1.37-4.485a1.649,1.649,0,1,1-1.747,1.67,1.719,1.719,0,0,1,1.747-1.67",
    transform: "translate(-210.789 -166.238)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12645",
    "data-name": "\\uD328\\uC2A4 12645",
    d: "M241.136,193.711l3.021-.047.022,1.38h.042a3.208,3.208,0,0,1,2.863-1.634c3.09-.05,3.695,1.976,3.738,4.623l.087,5.391h-3.134v-4.71c.025-1.142-.019-2.612-1.59-2.586-1.593.026-1.816,1.275-1.837,2.56v4.736l-3.047.049Z",
    transform: "translate(-233.301 -186.064)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.65729d236aa1274b7b1363a84c71ec3a.svg";
export { ForwardRef as ReactComponent };